import { instance3 } from "App/constants"

export const urlGet = "/master/jasa/ms_jasa/list"
export const urlExport = "/master/jasa/ms_jasa/list-export"
export const urlCreate = "/master/jasa/ms_jasa/add"
export const urlUpdate = "/master/jasa/ms_jasa/updateHarga"
export const urlUpdateAll = "/master/jasa/ms_jasa/updateAll"
export const urlDelete = "/master/jasa/ms_jasa/delete"

export const urlGetJenisJasa = "/master/jasa/js_jasa/list"

export const RESET_STATE_JASA = {
  id_jenis_jasa: 2,
  id_tarif_cbg: null,
  tarif_cbg: "Pilih CBG",
  id_jenis_harga: 0,
  nama: "",
  harga: "",
  status: 1,

  is_emr: 0,
  is_rajal: 0,
  is_ranap: 0,
  is_igd: 0,
  is_perawat: 0,
  id_template: 0,
  nama_template: "",
  kode_snomed: null,
}

export const RESET_STATE_FORM_FILTER = {
  id_jenis_harga: "",
  pages: 1,
  limit: 10,

  nama: "",
  id: "",
  is_emr: 0,
  is_rajal: 0,
  is_ranap: 0,
  is_igd: 0,
  is_perawat: 0,
}

export const getByFilterJenisHargaExport = async (
  formFilter,
  url = urlExport,
) => {
  try {
    const api = await instance3.post(url, {
      id_msHarga: formFilter.id_jenis_harga,
      nama: formFilter.nama,
      id: formFilter.id,
      is_emr: formFilter.is_emr,
      is_rajal: formFilter.is_rajal,
      is_ranap: formFilter.is_ranap,
      is_rigd: formFilter.is_rigd,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
      }
    } else {
      return {
        state: false,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterJenisHarga = async (
  formFilter,
  pages,
  limit,
  url = urlGet,
) => {
  try {
    const api = await instance3.post(url, {
      id_msHarga: formFilter.id_jenis_harga,
      nama: formFilter.nama,
      id: formFilter.id,
      is_emr: formFilter.is_emr,
      is_rajal: formFilter.is_rajal,
      is_ranap: formFilter.is_ranap,
      is_rigd: formFilter.is_rigd,

      jumlah: limit,
      halaman: pages,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deleteJasaById = async (id) => {
  try {
    await instance3.post(
      urlDelete,
      {},
      {
        headers: {
          id: id,
        },
      },
    )
    return {
      state: true,
      message: "Berhasil menghapus data",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "id_template",
    disablePadding: false,
    label: "ID TEMPLATE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "KODE SNOMED",
    align: "left",
    minWidth: "150px",
  },
]
